import gql from 'graphql-tag';

export default gql`
  query publicTicketTypes($eventId: String!, $language: Language, $couponCode: String) {
    publicTicketTypes(eventId: $eventId, language: $language, couponCode: $couponCode) {
      id
      name
      price
      salePrice
      description
      limit
      soldQuantity
      createdAt
      dateRange {
        start
        end
      }
      groupLimit {
        min
        max
      }
      active
    }
  }
`;



// WEBPACK FOOTER //
// ./src/site-render/src/graphql/queries/publicTicketTypes.js